export default __webpack_public_path__ + "static/media/image-study-board-1-w@2x.6a405bc5.png";